<div class="user-inproeco">
  <img  src="../../../../assets/logoinproeco.png" alt="" />
  <div class="datos">
    <div>
      <p class="nombre">
        <span class="nombre__title">Usuario:</span><br>
        {{userLogged.email}}
      </p>
    </div>
  </div>
</div>
